import React, { useEffect, useRef, useState } from 'react'
import "./stylePlatform.css"
import { useDispatch, useSelector } from 'react-redux';
import INCSUBPlan from './plans/plans';
import INCSUBPools from '../pools/Pools';
import { setPathInfo, setPlatformPath } from '../../redux/commonSlice';
import INCSUBPoolDetails from '../pools/poolDetails';
import INCSUBTrendingCard from './trendingcards/TrendingCard';
import INCSUBPlatformRequest from './platformRequest.js/PlatformRequest';
import INCSUBAddPlatform from '../../components/platforms/AddPlatform';
import { setCategoryList, setIsAddCategory, setIsAddPlatform, setPlatformInfo, setPlatformList, setPlatformPathRoot } from '../../features/platforms/platformsSlice';
import { deletePlatform, getCategoryList, getPlatformbyCategory, getPlatformList, updatePlatform } from '../../services/platformServices';
import INCSUBSearchbar from '../../components/common/SearchBar/INCSUBSearchbar';
import ReactPaginate from 'react-paginate';
import INCSUBCategory from '../../components/platforms/category/Category';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import StarRatings from 'react-star-ratings';



function INCSUBPlatforms() {
    // State to manage the visibility of the dropdown menu for selecting types
    const [isOpenType, setIsOpenType] = useState(false);

    // Refs to track elements for handling click outside functionality
    const refType = useRef(null);
    const refCardMenu = useRef(null);

    // Fetching platformPath from Redux store
    const platformPath = useSelector((state) => state.common.platformPath);

    // Dispatch function from Redux for state management
    const dispatch = useDispatch();

    // Fetching state values related to platforms from Redux store
    const isAddPlatform = useSelector((state) => state.platforms.isAddPlatform);
    const categoryList = useSelector((state) => state.platforms.categoryList);
    const platformList = useSelector((state) => state.platforms.platformList);
    const isAddCategory = useSelector((state) => state.platforms.isAddCategory);

    // State for managing pagination
    const [pageNumber, setPageNumber] = useState(0);

    // State to manage selected category with a default value
    const [category, setCategory] = useState({ categoryId: null, categoryName: "All" });

    // State to track the selected platform
    const [selectedPlatform, setSelectedPlatform] = useState(null);

    // State to control the popup visibility
    const [isOpenPopUp, setIsOpenPopup] = useState(false);

    // State to manage loading state for category data
    const [categoryLoader, setCategoryLoader] = useState(false);

    // State to track whether user is being prompted
    const [isAsk, setIsAsk] = useState(false);

    // State to manage the visibility of a menu
    const [isOpenMenu, setIsOpenmenu] = useState(null)



    // Function to handle clicks outside specified elements (closes menus)
    const handleClickOutside = (event) => {
        if (refType.current && !refType.current.contains(event.target)) {
            setIsOpenType(false);
        }
        if (refCardMenu.current && !refCardMenu.current.contains(event.target)) {
            setIsOpenmenu(false);
        }

    };

    // Effect to add and remove event listener for click outside functionality
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);



    // Function to fetch categories and update the Redux store
    const fetchCategory = async (e = 0) => {
        try {
            const data = await getCategoryList();
            dispatch(setCategoryList(data));

        } catch (error) {
            console.error("Error fetching CategoryList list:", error);
        }
    };


    // State and predefined list for shimmer effect (loading placeholder)
    const [shimmer, setShimmer] = useState(false);
    const shimmerList = [1, 2, 3, 4, 5];
    const fetchData = async (e = 0) => {
        setShimmer(true);
        try {
            const data = await getPlatformList(null, e);
            if (data.status === 401) {
                navigate('/login'); // Redirects to login page if unauthorized
                return
            }

            dispatch(setPlatformList(data));
            setShimmer(false);
        } catch (error) {
            console.error("Error fetching platform list:", error);
            setShimmer(false);
        }
    };

    // Function to fetch platform data filtered by category
    const fetchDataByCategory = async (category) => {
        try {
            const data = await getPlatformbyCategory(category.categoryId, 0);
            dispatch(setPlatformList(data));
        } catch (error) {
            console.error("Error fetching platform list:", error);
        }
    }


    // Function to handle category selection and fetch relevant data
    const handleCategory = (category) => {
        setCurrentPage(0);
        setCategory(category);
        if (category.categoryName === 'All') {
            fetchData();
        } else {
            fetchDataByCategory(category, 0)
        }
    }

    // Effect to fetch category and platform data on component mount
    useEffect(() => {
        if (!categoryList) {
            fetchCategory();
        }
        fetchData();
    }, []);


    const handlePlatform = async (selectedPlatform, isVisible) => {
        const newPlatform = {
            isVisible: isVisible,
            platformId: selectedPlatform.platformId,
            updateVisibility: true
        };
        try {
            const data = await updatePlatform(newPlatform);

            if (data.status === 200) {
                const updatedList = platformList.platformList.map(platform =>
                    platform.platformId === selectedPlatform.platformId
                        ? { ...platform, isVisible: isVisible }
                        : platform
                );

                dispatch(setPlatformList({
                    ...platformList,
                    platformList: updatedList
                }));
            }

            if (data.status === 401) {
                window.localStorage.setItem('token', null);
                navigate('/login');
                return;
            }

            if ([409, 400, 403].includes(data.status)) {
                toast.error(data.data.message);
            }

        } catch (err) {
            console.error("Error updating platform:", err);
        }
    };
    //for pagination functionality
    const [currentPage, setCurrentPage] = useState(0);
    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(2);

        const pageCount = platformList ? platformList.totalPages : 0;
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            setCurrentPage(event.selected)
            if (category.categoryName === 'All') {
                fetchData(event.selected);
            } else {
                fetchDataByCategory(category, event.selected)
            }

            setItemOffset(event.selected);
        };


        return (

            <div className='INCSUBPlatforms_list_section_ctn'>{
                !shimmer && platformList && platformList.platformList && platformList.platformList.length > 0 && pageCount > 1 ? <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={currentPage}
                /> : null
            }



            </div>


        );
    }
    // Hook to navigate between routes
    const navigate = useNavigate();

    /**
 * Function to handle the deletion of a selected platform.
 */
    const handleDeletePlatform = async () => {
        setCategoryLoader(true)
        try {
            const response = await deletePlatform(selectedPlatform);

            if (response) {
                if (response.status === 200) {
                    // Filter out the deleted platform from the list
                    const updatedPlatformList = platformList.platformList.filter((platform) => platform.platformId !== selectedPlatform.platformId);
                    dispatch(setPlatformList({
                        ...platformList,
                        platformList: updatedPlatformList
                    }));
                    // Update Redux store with the new platform list
                    toast.success("Deleted Successfuly");
                    setCategoryLoader(false)
                    setSelectedPlatform(null);
                    setIsOpenPopup(false);
                    setIsAsk(false);
                }
                if (response.status === 403) {
                    // If deletion is forbidden, update visibility instead of removing
                    setSelectedPlatform((prev) => {
                        const updatedPlatform = { ...prev, isVisible: false };
                        const updatedList = platformList.platformList.map(platform =>
                            platform.platformId === selectedPlatform.platformId
                                ? { ...platform, isVisible: false }
                                : platform
                        );

                        dispatch(setPlatformList({
                            ...platformList,
                            platformList: updatedList
                        }));
                        toast.success(response.message);
                        setCategoryLoader(false)
                        setSelectedPlatform(null);
                        setIsOpenPopup(false);
                        setIsAsk(false);
                        return updatedPlatform;
                    });


                }
                if (response.status === 401) {
                    navigate('/login');
                }
                if ([400, 404].includes(response.status)) {
                    toast.error(response.message);
                }
            }
        } catch (err) {
            toast.error("Something Went Wrong")
        }
        setCategoryLoader(false)

    }

    return (
        <div className='INCSUBPlatforms'>{
            platformPath === '/platforms' ? (

                <div className='INCSUBPlatforms_container'>
                    <div className='INCSUBPlatforms_filter_section_container'>
                        <div className='INCSUBPlatforms_filter_section'>
                            <INCSUBSearchbar source={'platforms'} placeholder={'Search by platform name, categories name'} param={{ pageNumber: pageNumber }} />
                            <div className='INCSUBPlatforms_type_filter'>
                                <div className='INCSUBPlatforms_type_filter_input' onClick={() => setIsOpenType(!isOpenType)}>{category.categoryName}<span>{category.categoryName === 'All' ? "(By Category)" : null}</span><svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.3126 5.54697C5.17753 5.68199 4.99437 5.75784 4.8034 5.75784C4.61242 5.75784 4.42926 5.68199 4.2942 5.54697L0.219877 1.47265C0.151088 1.40621 0.0962192 1.32674 0.0584729 1.23887C0.0207266 1.151 0.000858202 1.05649 2.71931e-05 0.96086C-0.000803816 0.865229 0.0174193 0.77039 0.0536329 0.681876C0.0898466 0.593363 0.143326 0.512948 0.21095 0.445324C0.278574 0.3777 0.358988 0.324221 0.447501 0.288008C0.536014 0.251794 0.630854 0.233571 0.726485 0.234402C0.822116 0.235233 0.916624 0.255102 1.00449 0.292848C1.09236 0.330594 1.17184 0.385462 1.23828 0.454251L4.8034 4.01937L8.36852 0.454251C8.50435 0.323056 8.68628 0.250462 8.87512 0.252103C9.06396 0.253744 9.24461 0.329489 9.37814 0.463025C9.51168 0.59656 9.58742 0.777202 9.58907 0.966043C9.59071 1.15488 9.51811 1.33682 9.38692 1.47265L5.3126 5.54697Z" fill="black" />
                                </svg>
                                </div>{
                                    isOpenType ? <div ref={refType} className='INCSUBPlatforms_type_filter_list'>
                                        <ul><li onClick={() => handleCategory({ categoryId: null, categoryName: "All" })}>All</li>
                                            {
                                                categoryList && categoryList.length > 0 && categoryList.map((category) => <li onClick={() => handleCategory(category)} key={category.categoryId}>{category.categoryName}</li>)
                                            }
                                        </ul>
                                        <div className='edit_section_btn' onClick={() => {
                                            dispatch(setIsAddCategory(true))
                                            setIsOpenType(false)
                                        }}><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8 13.3281H14" stroke="#646464" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M11 2.33609C11.2652 2.07087 11.6249 1.92188 12 1.92188C12.1857 1.92188 12.3696 1.95845 12.5412 2.02953C12.7128 2.1006 12.8687 2.20477 13 2.33609C13.1313 2.46741 13.2355 2.62331 13.3066 2.79489C13.3776 2.96647 13.4142 3.15037 13.4142 3.33609C13.4142 3.52181 13.3776 3.7057 13.3066 3.87728C13.2355 4.04886 13.1313 4.20477 13 4.33609L4.66667 12.6694L2 13.3361L2.66667 10.6694L11 2.33609Z" stroke="#646464" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Edit Categories</div>
                                    </div> : null
                                }

                            </div>

                        </div>
                        <div className='INCSUBPlatforms_filter_section_btns_container'>
                            <div className='INCSUBPlatforms_filter_section_btn trending_cards' onClick={() => dispatch(setPlatformPath("/trendingcards"))}>Trending Cards</div>
                            <div className='INCSUBPlatforms_filter_section_btn suggestions' onClick={() => dispatch(setPlatformPath("/suggestions"))}>Suggestions</div>
                            <div className='INCSUBPlatforms_filter_section_btn add_platforms' onClick={() => {
                                setSelectedPlatform(null);
                                dispatch(setIsAddPlatform(true))
                            }}>Add Platforms</div>
                        </div>
                    </div>
                    <div className='INCSUBPlatforms_list_section'>
                        <div className='INCSUBPlatform_list_container'>
                            {shimmer ? shimmerList && shimmerList.map(shimmer => <div className="INCSUBPlatforms_card shimmer">
                                <div className="h-60 w-100 bg-gray-300 rounded mb-4"></div>
                                <div className="space-y-2 m-1">
                                    <div className="h-6 bg-gray-300 rounded"></div>
                                    <div className="h-4 bg-gray-300 rounded"></div>
                                    <div className="h-4 bg-gray-300 rounded"></div>
                                </div>
                            </div>)
                                :
                                (platformList && platformList.platformList && platformList.platformList.length > 0 ? platformList.platformList.map((platform) => <div className='INCSUBPlatforms_card' key={platform.platformId}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        dispatch(setPlatformPath("/platform/plan"));
                                        dispatch(setPlatformInfo(platform));
                                        dispatch(setPathInfo(platform.platformName + '/'))
                                        dispatch(setPlatformPathRoot(platform.platformName))
                                    }
                                    }>
                                    <div className='INCSUBPlatforms_image_container'>
                                        <img src={platform.platformImage} style={{ height: "100%", width: '100%' }} alt='platform_image' />
                                    </div>
                                    <div className='INCSUBPlatforms_info_conatiner'>
                                        <div className='INCSUBPlatforms_info_header_container'>
                                            <div className='INCSUBPlatforms_info_header'>{platform.platformName}</div>
                                            <div className='menubtn' onClick={(e) => e.stopPropagation()}>
                                                <svg onClick={(e) => {
                                                    e.stopPropagation();
                                                    setIsOpenmenu(platform.platformId)
                                                }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.99984 10.8307C10.4601 10.8307 10.8332 10.4576 10.8332 9.9974C10.8332 9.53716 10.4601 9.16406 9.99984 9.16406C9.5396 9.16406 9.1665 9.53716 9.1665 9.9974C9.1665 10.4576 9.5396 10.8307 9.99984 10.8307Z" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M9.99984 5.0026C10.4601 5.0026 10.8332 4.62951 10.8332 4.16927C10.8332 3.70903 10.4601 3.33594 9.99984 3.33594C9.5396 3.33594 9.1665 3.70903 9.1665 4.16927C9.1665 4.62951 9.5396 5.0026 9.99984 5.0026Z" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M9.99984 16.6667C10.4601 16.6667 10.8332 16.2936 10.8332 15.8333C10.8332 15.3731 10.4601 15 9.99984 15C9.5396 15 9.1665 15.3731 9.1665 15.8333C9.1665 16.2936 9.5396 16.6667 9.99984 16.6667Z" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                {isOpenMenu === platform.platformId ? <div className='menu' ref={refCardMenu}>
                                                    <svg onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedPlatform(platform)
                                                        dispatch(setIsAddPlatform(true))
                                                    }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8 13.3281H14" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M11 2.33609C11.2652 2.07087 11.6249 1.92188 12 1.92188C12.1857 1.92188 12.3696 1.95845 12.5412 2.02953C12.7128 2.1006 12.8687 2.20477 13 2.33609C13.1313 2.46741 13.2355 2.62331 13.3066 2.79489C13.3776 2.96647 13.4142 3.15037 13.4142 3.33609C13.4142 3.52181 13.3776 3.7057 13.3066 3.87728C13.2355 4.04886 13.1313 4.20477 13 4.33609L4.66667 12.6694L2 13.3361L2.66667 10.6694L11 2.33609Z" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                    <hr />
                                                    <svg onClick={(e) => {
                                                        e.stopPropagation();
                                                        setIsOpenPopup(true);
                                                        setSelectedPlatform(platform);
                                                        setIsAsk(true)
                                                    }
                                                    } width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2 4H3.33333H14" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M12.6668 4.0026V13.3359C12.6668 13.6896 12.5264 14.0287 12.2763 14.2787C12.0263 14.5288 11.6871 14.6693 11.3335 14.6693H4.66683C4.31321 14.6693 3.97407 14.5288 3.72402 14.2787C3.47397 14.0287 3.3335 13.6896 3.3335 13.3359V4.0026M5.3335 4.0026V2.66927C5.3335 2.31565 5.47397 1.97651 5.72402 1.72646C5.97407 1.47641 6.31321 1.33594 6.66683 1.33594H9.3335C9.68712 1.33594 10.0263 1.47641 10.2763 1.72646C10.5264 1.97651 10.6668 2.31565 10.6668 2.66927V4.0026" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M6.6665 7.33594V11.3359" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M9.3335 7.33594V11.3359" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                    <hr />
                                                    {!platform.isVisible ? <svg onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePlatform(platform, true)
                                                    }} width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.2485 5.97656C11.2485 6.5733 11.0115 7.1456 10.5895 7.56755C10.1676 7.98951 9.59527 8.22656 8.99854 8.22656C8.4018 8.22656 7.8295 7.98951 7.40754 7.56755C6.98559 7.1456 6.74854 6.5733 6.74854 5.97656C6.74854 5.37983 6.98559 4.80753 7.40754 4.38557C7.8295 3.96362 8.4018 3.72656 8.99854 3.72656C9.59527 3.72656 10.1676 3.96362 10.5895 4.38557C11.0115 4.80753 11.2485 5.37983 11.2485 5.97656Z" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M1.49902 5.98437C2.69902 2.91162 5.50102 0.734375 8.99902 0.734375C12.497 0.734375 15.299 2.91162 16.499 5.98437C15.299 9.05712 12.497 11.2344 8.99902 11.2344C5.50102 11.2344 2.69902 9.05712 1.49902 5.98437Z" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>


                                                        :
                                                        <svg onClick={(e) => {
                                                            e.stopPropagation();
                                                            handlePlatform(platform, false)
                                                        }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_81_35113)">
                                                                <path d="M11.9598 11.9574C10.8202 12.8261 9.43258 13.3073 7.99984 13.3307C3.33317 13.3307 0.666504 7.99741 0.666504 7.99741C1.49576 6.45201 2.64593 5.10182 4.03984 4.03741M6.59984 2.82408C7.05873 2.71667 7.52855 2.66297 7.99984 2.66408C12.6665 2.66408 15.3332 7.99741 15.3332 7.99741C14.9285 8.75448 14.4459 9.46724 13.8932 10.1241M9.41317 9.41075C9.23007 9.60724 9.00927 9.76485 8.76394 9.87416C8.51861 9.98347 8.25377 10.0423 7.98523 10.047C7.71669 10.0517 7.44995 10.0023 7.20091 9.90174C6.95188 9.80115 6.72565 9.65143 6.53574 9.46151C6.34582 9.2716 6.1961 9.04537 6.09551 8.79634C5.99492 8.5473 5.94552 8.28056 5.95026 8.01202C5.955 7.74348 6.01378 7.47864 6.12309 7.23331C6.2324 6.98798 6.39001 6.76718 6.5865 6.58408" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M0.666504 0.664062L15.3332 15.3307" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_81_35113">
                                                                    <rect width="16" height="16" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>


                                                    }

                                                </div> : null}
                                            </div>
                                        </div>
                                        <div className='INCSUBPlatforms_category_rating'>
                                            <div className='INCSUBPlatforms_category'>{platform.platformCategory}</div>
                                            <div className='INCSUBPlatforms_rating_conrtainer'>
                                                <StarRatings
                                                    rating={typeof platform.platformRating === 'number'
                                                        ? platform.platformRating
                                                        : parseFloat(platform.platformRating) || 0}
                                                    starRatedColor="#FF9500"
                                                    //   changeRating={this.changeRating}
                                                    numberOfStars={5}
                                                    name='rating'
                                                    starSpacing='1px'
                                                    starDimension='16px'
                                                />
                                            </div>
                                            <div className='ratingCountContainer'>({platform?.platformReviewCount})</div>
                                        </div>
                                        <div className='INCSUBPlatforms_category_pf_overview_container'>
                                            <div className='INCSUBPlatforms_category_overview_info'>
                                                <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="2" cy="2" r="2" fill="#4880FF" />
                                                </svg>
                                                {platform.planCount ? platform.planCount : 0} Plans
                                            </div>
                                            <div className='INCSUBPlatforms_category_overview_info'>
                                                <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="2" cy="2" r="2" fill="#4880FF" />
                                                </svg>
                                                {platform.poolCount ? platform.poolCount : 0} Pools
                                            </div>
                                            <div className='INCSUBPlatforms_category_overview_info'>
                                                <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="2" cy="2" r="2" fill="#4880FF" />
                                                </svg>
                                                {platform.userCount ? platform.userCount : 0} Users
                                            </div>
                                        </div>
                                    </div>
                                </div>):<div className='INCSUBPlatorm_empty'>No Platform Added Yet</div>
                                )}</div>

                    </div>
                    <PaginatedItems />
                </div>)
                : platformPath === "/platform/plan" ? (
                    <INCSUBPlan />
                ) : platformPath === "/platform/plan/pools" ? (
                    <INCSUBPools />
                ) : platformPath === "/platform/plan/pools/poolsDetails" ? (
                    <INCSUBPoolDetails />
                ) : platformPath === "/trendingcards" ? (
                    <INCSUBTrendingCard />
                ) : platformPath === "/suggestions" ? (
                    <INCSUBPlatformRequest />
                ) : null
        }{isAddPlatform ?
            <INCSUBAddPlatform platform={selectedPlatform} /> : null
            }
            {isAddCategory ?
                <INCSUBCategory /> : null
            }
            {isOpenPopUp ?
                <div className='INCSUBCategory_permission_popup'>{
                    isAsk ?
                        <div className='INCSUBCategory_ask_container' >
                            <div className='INCSUBCategory_ask' style={{ display: categoryLoader ? 'none' : null }}>
                                <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="49.0815" cy="46.0102" r="32.0883" fill="#00B64C" />
                                    <path d="M60.983 36.3818C60.8251 36.2039 60.6372 36.0627 60.4301 35.9663C60.223 35.8699 60.001 35.8203 59.7766 35.8203C59.5523 35.8203 59.3302 35.8699 59.1232 35.9663C58.9161 36.0627 58.7282 36.2039 58.5702 36.3818L45.9115 50.5421L40.5932 44.5818C40.4292 44.4049 40.2356 44.2657 40.0234 44.1723C39.8113 44.0789 39.5848 44.0331 39.3568 44.0375C39.1288 44.0419 38.9038 44.0964 38.6947 44.198C38.4855 44.2995 38.2963 44.4461 38.1379 44.6293C37.9795 44.8125 37.8549 45.0288 37.7713 45.2658C37.6877 45.5028 37.6467 45.7558 37.6507 46.0105C37.6546 46.2652 37.7034 46.5166 37.7943 46.7502C37.8852 46.9838 38.0164 47.1952 38.1804 47.3721L44.7051 54.6611C44.8631 54.839 45.051 54.9802 45.2581 55.0766C45.4651 55.1729 45.6872 55.2225 45.9115 55.2225C46.1359 55.2225 46.3579 55.1729 46.565 55.0766C46.7721 54.9802 46.96 54.839 47.1179 54.6611L60.983 39.1721C61.1555 38.9943 61.2932 38.7786 61.3873 38.5385C61.4815 38.2984 61.5301 38.0391 61.5301 37.7769C61.5301 37.5148 61.4815 37.2555 61.3873 37.0154C61.2932 36.7753 61.1555 36.5595 60.983 36.3818Z" fill="white" />
                                    <circle cx="13.778" cy="7.87368" r="7.87368" fill="#00B64C" fill-opacity="0.2" />
                                    <circle cx="93.1719" cy="15.749" r="5.90526" fill="#00B64C" fill-opacity="0.2" />
                                    <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#00B64C" fill-opacity="0.2" />
                                    <circle cx="34.777" cy="91.2028" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                    <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                    <circle cx="89.235" cy="58.3903" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                    <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                </svg>

                                <div className='INCSUBCategory_permission_header'>
                                    Are you sure to delete this Platform?
                                </div>
                                <div className='INCSUBCategory_permission_btn_container'>
                                    <div className="INCSUBCategory_image_upload_btn">
                                        <div className='INCSUBCategory_upload_btn' onClick={handleDeletePlatform}>Delete</div>
                                        <div className='upload_cancel_btn' onClick={() => {
                                            setIsOpenPopup(false);
                                            setSelectedPlatform(null);
                                            setIsAsk(false);
                                        }}>Cancel</div>
                                    </div>
                                </div>
                            </div>
                            {
                                categoryLoader ? <div className='categoryloader' /> : null
                            }
                        </div> : <div className='INCSUBCategory_ask_container'>
                            <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="49.0805" cy="46.0102" r="32.0883" fill="#FF6565" />
                                <path d="M59 37L41 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M41 37L59 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                <circle cx="13.778" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="93.1709" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                                <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="34.777" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="89.234" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                            </svg>
                            <div className='INCSUBCategory_permission_header'>
                                Can’t delete
                            </div>
                            <div className='INCSUBCategory_permission_text'>There are platforms in this category.</div>
                            <div className='INCSUBCategory_permission_btn_container'>
                                <div className="INCSUBCategory_image_upload_btn">
                                    <div className='INCSUBCategory_upload_btn' onClick={() => {
                                        setIsOpenPopup(false)
                                        setSelectedPlatform(null)
                                    }}>Ok, Got it</div>
                                </div>
                            </div>
                        </div>
                }


                </div> : null
            }
        </div>
    )
}

export default INCSUBPlatforms
